import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.796129, 165.816704, 5],
  [-10.796221, 165.816683, 5],
  [-10.79631, 165.816672, 4.8],
  [-10.796398, 165.81664, 4.8],
  [-10.796484, 165.816597, 4.8],
  [-10.796567, 165.816543, 4.8],
  [-10.796648, 165.8165, 4.8],
  [-10.796721, 165.816436, 4.8],
  [-10.796789, 165.816382, 4.8],
  [-10.796849, 165.816307, 4.8],
  [-10.796892, 165.816211, 4.8],
  [-10.796915, 165.816125, 4.6],
  [-10.796922, 165.816028, 4.6],
  [-10.79692, 165.815942, 4.6],
  [-10.796915, 165.815846, 4.4],
  [-10.796909, 165.815749, 4.4],
  [-10.796911, 165.815663, 4.4],
  [-10.796931, 165.815567, 4.4],
  [-10.796976, 165.815492, 4.6],
  [-10.797039, 165.815438, 4.8],
  [-10.797111, 165.815406, 5.2],
  [-10.797184, 165.815374, 5.4],
  [-10.797258, 165.815341, 5.8],
  [-10.797329, 165.815331, 6],
  [-10.797399, 165.815331, 6.2],
  [-10.797466, 165.815309, 6.6],
  [-10.797532, 165.815299, 6.8],
  [-10.797596, 165.815299, 7],
  [-10.797658, 165.815299, 7.2],
  [-10.797719, 165.815277, 7.4],
  [-10.797778, 165.815266, 7.6],
  [-10.797835, 165.815256, 7.8],
  [-10.79789, 165.815234, 8],
  [-10.797943, 165.815202, 8.2],
  [-10.797996, 165.815191, 8.2],
  [-10.798044, 165.815159, 8.4],
  [-10.798089, 165.815116, 8.4],
  [-10.79813, 165.815063, 8.4],
  [-10.798166, 165.81502, 8.4],
  [-10.798195, 165.814966, 8.4],
  [-10.798219, 165.814902, 8.2],
  [-10.798239, 165.814837, 8.2],
  [-10.798254, 165.814762, 8],
  [-10.798266, 165.814698, 7.8],
  [-10.798277, 165.814623, 7.6],
  [-10.798288, 165.814548, 7.4],
  [-10.7983, 165.814462, 7.2],
  [-10.798316, 165.814376, 7],
  [-10.798342, 165.814301, 6.8],
  [-10.798381, 165.814226, 6.6],
  [-10.798446, 165.814151, 6.8],
  [-10.798524, 165.814118, 6.8],
  [-10.798606, 165.814086, 7],
  [-10.79869, 165.814065, 7.4],
  [-10.798781, 165.814065, 7.8],
  [-10.798858, 165.814065, 8],
  [-10.798935, 165.814065, 8.4],
  [-10.799011, 165.814065, 8.6],
  [-10.799083, 165.814065, 9],
  [-10.799153, 165.814075, 9.2],
  [-10.799219, 165.814075, 9.6],
  [-10.799284, 165.814075, 9.8],
  [-10.799345, 165.814086, 10],
  [-10.799406, 165.814108, 10.4],
  [-10.799463, 165.814108, 10.6],
  [-10.79952, 165.814118, 10.8],
  [-10.799572, 165.81414, 11.2],
  [-10.79962, 165.814172, 11.4],
  [-10.799663, 165.814193, 11.6],
  [-10.799705, 165.814226, 11.8],
  [-10.799746, 165.814258, 12],
  [-10.799786, 165.81429, 12.2],
  [-10.799826, 165.814322, 12.4],
  [-10.799865, 165.814354, 12.6],
  [-10.799901, 165.814376, 12.8],
  [-10.799933, 165.81443, 13],
  [-10.799964, 165.814472, 13.2],
  [-10.799987, 165.814515, 13.4],
  [-10.800002, 165.814569, 13.6],
  [-10.80001, 165.814612, 14],
  [-10.800012, 165.814655, 14.2],
  [-10.80001, 165.814698, 14.4],
  [-10.800005, 165.814751, 14.6],
  [-10.8, 165.814773, 14.8],
  [-10.799991, 165.814826, 15],
  [-10.79998, 165.814869, 15.2],
  [-10.799967, 165.814912, 15.4],
  [-10.799953, 165.814966, 15.6],
  [-10.799935, 165.815009, 15.8],
  [-10.799915, 165.815041, 16],
  [-10.799892, 165.815084, 16.2],
  [-10.799867, 165.815127, 16.4],
  [-10.799839, 165.815159, 16.6],
  [-10.799809, 165.815191, 17],
  [-10.799775, 165.815223, 17.2],
  [-10.799741, 165.815234, 17.4],
  [-10.799704, 165.815266, 17.8],
  [-10.799668, 165.815277, 18],
  [-10.79963, 165.815299, 18.4],
  [-10.799591, 165.815299, 18.6],
  [-10.799553, 165.815299, 18.8],
  [-10.799514, 165.815299, 19],
  [-10.799474, 165.815299, 19.2],
  [-10.799435, 165.815299, 19.4],
  [-10.799395, 165.815277, 19.6],
  [-10.799355, 165.815277, 19.8],
  [-10.799314, 165.815266, 20],
  [-10.799274, 165.815256, 20.2],
  [-10.799234, 165.815234, 20.2],
  [-10.799194, 165.815202, 20.4],
  [-10.799156, 165.815191, 20.6],
  [-10.799119, 165.815159, 20.8],
  [-10.799082, 165.815148, 21],
  [-10.799048, 165.815116, 21.4],
  [-10.799014, 165.815084, 21.6],
  [-10.798984, 165.815052, 21.8],
  [-10.798957, 165.81502, 22],
  [-10.798934, 165.814977, 22.4],
  [-10.798915, 165.814945, 22.6],
  [-10.798901, 165.814912, 23],
  [-10.798891, 165.814869, 23.2],
  [-10.798883, 165.814837, 23.4],
  [-10.798878, 165.814794, 23.6],
  [-10.798874, 165.814762, 23.8],
  [-10.798873, 165.814719, 24],
  [-10.798874, 165.814687, 24.2],
  [-10.798875, 165.814644, 24.4],
  [-10.798878, 165.81459, 24.6],
  [-10.798882, 165.814569, 24.8],
  [-10.798887, 165.814515, 25],
  [-10.798891, 165.814472, 25.2],
  [-10.798897, 165.81443, 25.2],
  [-10.798903, 165.814376, 25.4],
  [-10.798911, 165.814333, 25.4],
  [-10.798922, 165.81429, 25.4],
  [-10.798934, 165.814226, 25.6],
  [-10.798946, 165.814172, 25.6],
  [-10.79896, 165.814108, 25.4],
  [-10.798974, 165.814043, 25.4],
  [-10.798989, 165.813979, 25.2],
  [-10.799003, 165.813904, 25],
  [-10.799017, 165.813829, 25.2],
  [-10.799032, 165.813754, 25.4],
  [-10.799049, 165.813679, 25.6],
  [-10.799066, 165.813603, 25.6],
  [-10.799086, 165.813528, 25.4],
  [-10.799107, 165.813453, 25.2],
  [-10.799128, 165.813378, 25],
  [-10.799146, 165.813292, 24.6],
  [-10.799163, 165.813217, 24.4],
  [-10.799178, 165.813131, 24.2],
  [-10.799194, 165.813035, 23.8],
  [-10.799212, 165.81296, 23.4],
  [-10.799228, 165.812874, 23.2],
  [-10.799245, 165.812777, 22.8],
  [-10.799263, 165.81267, 22.4],
  [-10.799285, 165.812584, 22],
  [-10.799311, 165.812488, 21.6],
  [-10.799339, 165.812402, 21.2],
  [-10.799374, 165.812294, 20.6],
  [-10.799414, 165.812198, 20.2],
  [-10.799461, 165.812112, 19.6],
  [-10.799517, 165.812016, 19],
  [-10.799582, 165.811919, 18.4],
  [-10.799668, 165.811844, 17.6],
  [-10.799774, 165.811822, 17],
  [-10.799888, 165.811801, 16.2],
  [-10.800005, 165.811801, 15.6],
  [-10.800122, 165.811822, 15],
  [-10.800239, 165.811833, 14.4],
  [-10.800359, 165.811844, 13.6],
  [-10.800479, 165.811865, 13],
  [-10.800601, 165.811865, 12.2],
  [-10.800723, 165.811876, 11.6],
  [-10.800845, 165.811865, 11],
  [-10.800967, 165.811844, 10.2],
  [-10.801076, 165.81179, 9.4],
  [-10.801156, 165.811683, 8.8],
  [-10.801202, 165.811576, 8],
  [-10.80123, 165.811436, 7.4],
  [-10.801247, 165.811318, 6.8],
  [-10.801246, 165.811189, 6.2],
  [-10.801232, 165.81105, 5.6],
  [-10.801216, 165.810932, 5.2],
  [-10.801209, 165.810814, 5.4],
  [-10.801207, 165.810685, 6],
  [-10.801201, 165.810578, 5.8],
  [-10.801191, 165.81046, 5.6],
  [-10.801179, 165.810353, 5],
  [-10.80116, 165.810235, 4.8],
];

export default stream;
